import { render, staticRenderFns } from "./ApiIndex.vue?vue&type=template&id=5d715207"
import script from "./ApiIndex.vue?vue&type=script&lang=js"
export * from "./ApiIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports